import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root',
})
export class AttendenceService {
    apiUrl = environment.apiUrl;
    urlExtenssion  = localStorage.getItem("urlExtenssion");
    constructor(private http: HttpClient) {
        this.urlExtenssion  = localStorage.getItem("urlExtenssion");
        if(this.urlExtenssion == null){
            this.urlExtenssion= ''
        }
     }
     updateUrlExtention(){
        this.urlExtenssion  = localStorage.getItem("urlExtenssion");
        if(this.urlExtenssion == null){
            this.urlExtenssion= ''
        }
      }
    // getKsaAttendence(country?) {
    //     return this.http.get(this.apiUrl + 'user/attendance', {params : {'country': country} });
    // }
    checkInUser(code : any) {
        this.updateUrlExtention();
        return this.http.get(this.apiUrl + `backoffice${this.urlExtenssion}/trainee/getWithCreditTodaySessions?code=${code}`);
    }

    //update tainee membership credit
    updateTraineeMembershipCredit(body : any) {

        this.updateUrlExtention();
        return this.http.put(this.apiUrl + `backoffice${this.urlExtenssion}/trainee/updateTraineeMembershipCredit`,body);
    }
    getAllAttendance() {
        return this.http.get(this.apiUrl + `getAllAttendance?`);
    }
    getAttendence(date  : any) {
        // date forma 2019-09-29
        return this.http.get(this.apiUrl + 'getAllTraineesByDate?date=' + date);
    }
    setAttendance(body : any) {
        return this.http.post(this.apiUrl + 'attendance', body);

    }
    getReports() {
        return this.http.get(this.apiUrl + `trainers_report`);
    }
    changeUserCredit(body : any){
        this.updateUrlExtention();
        return this.http.put(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/changeUserCredit`,body)
    }
    changeUserAttendStatus(body : any){
        this.updateUrlExtention();
        return this.http.put(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/changeUserAttendStatus`,body)
    }
    scheduleSharedSession(body : any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/scheduleSharedSession`,body)
    }
    getAvaSessions(traineeId : any, locationId : any, selectedDate : any){
        this.updateUrlExtention();
        return this.http.get(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/availableUserSessions?trainee_id=${traineeId}&date=${selectedDate}&location_id=${locationId}`);
    }
    BookAvaSessions(body : any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/scheduleSessionForTrainee`,body);
    }
    rescheduleSession(body : any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/rescheduleSessionForTrainee`,body);
    }
    cancelSession(body : any){
        this.updateUrlExtention();
        return this.http.post(this.apiUrl+`backoffice${this.urlExtenssion}/trainee/cancelSession`,body);
    }
}
